<template>
  <div>
    <v-snackbar justify-center v-model="showSnackBar" color="green" right :timeout="2000">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color:white">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex pt-16 text-left align-self-center>
        <v-card class="pa-4" height="100px">
          <v-layout wrap fill-height>
            <v-flex text-left align-self-center>
              <span style="font-family: poppinsmedium; font-size: 16px"
                >Delivery Distance - Grocery</span
              >
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex pt-16 text-left align-self-center>
        <v-card class="pa-4" height="100px" v-for="(item,i) in user" :key="i">
          <v-layout wrap fill-height>
            <v-flex text-left align-self-center>
              <span style="font-family: poppinsmedium; font-size: 16px"
                >Delivery Distance: {{ item.deliveryDistance }}</span
              >
            </v-flex>
            <v-flex text-left align-self-center>
              <span style="font-family: poppinsmedium"
                >Status: {{ item.status }} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              </span>
              <v-btn color="blue white--text" @click="(curitem = item),(editDialog=true)">EDIT</v-btn>
              <v-dialog width="600px" v-model="editDialog">
               
                <v-card width="600px">
                  <v-layout wrap pa-3>
                    <v-flex  xs12 class="sbold" text-center v-if="curitem">
                      <v-text-field v-model="curitem.deliveryDistance" outlined hide-details dense label="EDIT DISTANCE"></v-text-field>
                    </v-flex>
                    <v-flex xs12 text-right pt-2>
                      <v-btn
                        color="primary"
                        small
                        text
                        @click="EditData()"
                      >
                        ok</v-btn
                      >
                      <v-btn
                        color="error"
                        small
                        text
                        @click="editDialog = false"
                      >
                        cancel</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout wrap> </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      editDialog: false,
      user: [],
      curitem:null,
      showSnackBar: false,
      ServerError: false,
      appLoading: false,

      pages: 0,
      currentPage: 1,

      msg: null,
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    
    getData() {
      this.appLoading = true;
      axios({
        url: "/admin/delivery/distance",
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
        // params: {
        //   page: this.currentPage,
        //   limit: 50,
        //   searchKeyword: "",
        // },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.pages = Math.ceil(response.data.totalLength / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    EditData() {
      this.appLoading = true;
      axios({
        url: "/admin/edit/deliveryDistance/grocery",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          km: this.curitem.deliveryDistance,
          id:this.curitem._id
        },
      })
        .then((response) => {
          this.appLoading = false;
          if(response.data.status == true){
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.editDialog = false;
          this.user = response.data.data;
          this.pages = Math.ceil(response.data.totalLength / 50);
          this.getData();
          }
          else{
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

